import { Component, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-devider',
  templateUrl: './devider.component.html',
  styleUrl: './devider.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DeviderComponent {
  @HostBinding('class') private classList = 'devider';
}
